
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const BrandStoryPage = lazy(() => import('../pages/brand-story/page'));
const WhoWeServePage = lazy(() => import('../pages/who-we-serve/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const PrivateLabelPage = lazy(() => import('../pages/private-label/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const RoastedCoffeePage = lazy(() => import('../pages/products/roasted-coffee/page'));
const PodsPage = lazy(() => import('../pages/products/pods/page'));
const CapsulesPage = lazy(() => import('../pages/products/capsules/page'));
const MilkshakesPage = lazy(() => import('../pages/products/milkshakes/page'));
const HorecaPage = lazy(() => import('../pages/products/horeca/page'));
const TeaPage = lazy(() => import('../pages/products/tea/page'));
const MachinesPage = lazy(() => import('../pages/products/machines/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/brand-story',
    element: <BrandStoryPage />,
  },
  {
    path: '/who-we-serve',
    element: <WhoWeServePage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/products/roasted-coffee',
    element: <RoastedCoffeePage />,
  },
  {
    path: '/products/pods',
    element: <PodsPage />,
  },
  {
    path: '/products/capsules',
    element: <CapsulesPage />,
  },
  {
    path: '/products/milkshakes',
    element: <MilkshakesPage />,
  },
  {
    path: '/products/horeca',
    element: <HorecaPage />,
  },
  {
    path: '/products/tea',
    element: <TeaPage />,
  },
  {
    path: '/products/machines',
    element: <MachinesPage />,
  },
  {
    path: '/private-label',
    element: <PrivateLabelPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
